export default __webpack_public_path__ + "static/c1bb5d51d0a4b56ade93b71e70731686.jpeg";